import { purry } from './purry';
export function pathOr() {
  return purry(_pathOr, arguments);
}

function _pathOr(object, path, defaultValue) {
  var current = object;

  for (var _i = 0, path_1 = path; _i < path_1.length; _i++) {
    var prop = path_1[_i];

    if (current == null || current[prop] == null) {
      return defaultValue;
    }

    current = current[prop];
  }

  return current;
}